<template>
    <transition name="fade">
        <div :class="prefixCls" v-show="visible"
            >
            <div :class="`${prefixCls}-mask`" :style="{ 'z-index': 1000 + handleGetIndex() }"></div>
            <div :class="`${prefixCls}-inner ${prefixCls}-inner-${instanceTheme}`"
                :style="{
                    'z-index': 1000 + handleGetIndex()
                }">
                <div :class="`${prefixCls}-inner-loading`">
                    <svg x="0px" y="0px" viewBox="0 0 10 10" enable-background="new 0 0 10 10" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M7.7,8.2L7.7,8.2C7.6,8.2,7.6,8.2,7.7,8.2L7.7,8.2z M10,4.5l-1.5,0h0C8,4.5,7.6,4.9,7.6,5.4
			l1.5,0l0,0l0,0C9.6,5.4,10,5,10,4.5 M7.1,3.4l1.1-1.1l0,0c0.3-0.3,0.3-0.9,0-1.2L7.1,2.2l0,0C6.8,2.6,6.8,3.1,7.1,3.4 M5.4,2.4
			C4.9,2.4,4.6,2,4.6,1.5l0-1.5C5,0,5.4,0.4,5.4,0.9v0v0L5.4,2.4z M2.4,1.7L2.4,1.7l1.1,1.1c-0.3,0.3-0.9,0.3-1.2,0l0,0L1.1,1.8
			C1.5,1.4,2,1.4,2.4,1.7L2.4,1.7z M7.8,7.1L7.8,7.1l1.1,1.1C8.5,8.5,8,8.5,7.6,8.2L6.5,7.1C6.9,6.7,7.4,6.7,7.8,7.1z M5.4,8.4
			L5.4,8.4l0,1.5C5,9.9,4.6,9.5,4.6,9.1l0-1.5C5.1,7.5,5.4,7.9,5.4,8.4z M2.9,6.5c0.3,0.3,0.3,0.9,0,1.2l0,0l0,0L1.8,8.8
			c-0.3-0.3-0.3-0.9,0-1.2l0,0l0,0L2.9,6.5z M2.4,4.5C2.4,5,2,5.4,1.5,5.4L0,5.4c0-0.5,0.4-0.9,0.9-0.9L2.4,4.5z" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div :class="`${prefixCls}-inner-text`">{{instanceText}}</div>
            </div>
        </div>
    </transition>
</template>
<script>
    import { t } from '../../../locale/'
    import { oneOf } from '../../../utils/assist'
    import { transferIndex, transferIncrease } from '../../../utils/transfer-queue'
    
    const prefixCls = 'yy-loading'
    export default {
        name: 'YYLoading',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            theme: {
                validator (value) {
                    return oneOf(value, ['dark', 'light'])
                },
                default: 'dark'
            },
            text: {
                type: String,
                default: function() {
                    return t('loading')
                }
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                visible: this.value,
                instanceTheme: this.theme,
                instanceText: this.text
            }
        },
        watch: {
            value (value) {
                this.visible = value
            }
        },
        methods: {
            handleGetIndex () {
                transferIncrease()
                return transferIndex
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/base/loading/loading.vue